import { useAppSelector } from '@frontend/common';
import { SearchTextInput } from '@frontend/components/basic-forms';
import { changeFilter, ListInfo, listStore } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

const ID = 'search-filter';
interface SearchFilterProps {
    dispatch: ThunkDispatch<any, any, Action>;
    listId: string;
    placeholder?: string;
    label?: React.ReactNode | null;
    resetFilter?: boolean;
    className?: string;
}

export const SearchFilter = (props: SearchFilterProps) => {
    const intl = useIntl();
    const store = useAppSelector(useSelector, listStore);
    const list: ListInfo | undefined = store[props.listId];
    const [filterValue, changeFilterValue] = useState<string | null>(list?.filter?.['search'] as string | undefined | null ?? null);

    useEffect(() => {
        if (props.resetFilter) {
            changeFilterValue('');
        }
    }, [props.resetFilter]);
    useEffect(() => {
        if (filterValue === null) return;
        const timeOutId = setTimeout(() => filter(filterValue), 300);
        return () => clearTimeout(timeOutId);
    }, [filterValue]);

    const filter = async (value: string) => {
        if (value === '') {
            props.dispatch(changeFilter({listId: props.listId, key: 'search', value: null}));
        } else props.dispatch(changeFilter({listId: props.listId, key: 'search', value}));
    };

    return (
        <SearchTextInput
            id={ID + '-' + props.listId}
            className={props.className}
            placeholder={props.placeholder ? props.placeholder : intl.formatMessage({defaultMessage: 'Search', id: 'common.search', description: 'Search placeholder'})}
            value={filterValue}
            useConditionedStyling={false}
            onChange={changeFilterValue}
            submitted={false}
        />
    );
};
